var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"type":"text","placeholder":_vm.element.propValue},model:{value:(_vm.modelData[_vm.element.id]),callback:function ($$v) {_vm.$set(_vm.modelData, _vm.element.id, $$v)},expression:"modelData[element.id]"}})}
var staticRenderFns = []

export { render, staticRenderFns }